import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Button = (props) => {
	const buttonClassName = classnames({
		"c-button": true,
		[props.className]: props.className,
		"c-button--selected": props.selected,
		"c-button--disabled": props.disabled,
		"c-button--small": props.small
	});

	const content = props.children ? props.children : props.text;

	let buttonProps = {
		type: "button",
		autoFocus: props.autoFocus,
		className: buttonClassName,
		disabled: props.disabled,
		onClick: props.onClick,
		selected: props.selected
	};

	if (props.style) {
		buttonProps.style = props.style;
	}

	return (
		<button {...buttonProps}>
			{content}
		</button>);
};

Button.propTypes = {
	onClick: PropTypes.func,
	text: PropTypes.string.isRequired,
	className: PropTypes.string,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	autoFocus: PropTypes.bool,
	style: PropTypes.object,
	small: PropTypes.bool
};

export default Button;
